import ROUTES from "~/constants/routes";

import {
  NftCardAspectRatioVariant,
  NftCardInstanceVariant
} from "./declarations";

export const NFT_IMAGE_ASPECT_RATIO_BY_VARIANT = {
  [NftCardAspectRatioVariant.square]: 1,
  [NftCardAspectRatioVariant.elongated]: 0.563,
  [NftCardAspectRatioVariant.portrait]: 0.71
};

export const NFT_INSTANCE_BASE_PATH_BY_VARIANT = {
  [NftCardInstanceVariant.collection]: ROUTES.collections.instance,
  [NftCardInstanceVariant.item]: ROUTES.items.instance
};
